import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveOffcanvas, NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-full-filter',
  template: `
    <div class="offcanvas-header">
      <h4 class="offcanvas-title">Filtro</h4>      
			<button
				type="button"
				class="btn-close"
				aria-label="Close"
				(click)="dismiss()"
			></button>
    </div>
    <div class="offcanvas-body">
      <form [formGroup]="filterForm" (ngSubmit)="close()">
        <div class="form-group">
          <div class="form-check">
            <input class="form-check-input" 
                  type="checkbox" 
                  id="residentialCheck"
                  [checked]="filterForm.get('tipo')?.value === 0"
                  (change)="updateSettlementType($event, 0)">
            <label class="form-check-label" for="residentialCheck">Condominios</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" 
                  type="checkbox" 
                  id="commercialCheck"
                  [checked]="filterForm.get('tipo')?.value === 1"
                  (change)="updateSettlementType($event, 1)">
            <label class="form-check-label" for="commercialCheck">Comercial</label>
          </div>
        </div>
        <div *ngIf="showLegalEntity" class="form-group mt-4">
          <app-legal-entity-select formControlName="legal_entity_id" inputId="filter-legal-entity"
            [isCommercial]="null"></app-legal-entity-select>
          <div *ngIf="filterForm.get('legal_entity_id')?.errors?.['legalEntityInvalid']" class="text-danger text-sm mt-1">
            Selecciona una razón social del catálogo.
          </div>
        </div>
        <div class="form-group mt-4">
          <label for="settlement" class="form-label ms-2">Condominio</label>
          <select class="form-select rounded-4 bg-transparent" formControlName="settlement_id" (change)="selectSettlement($event)">
            <option selected value="">Condominio</option>
            <option *ngFor="let settlement of settlements" [value]="settlement.id" >{{settlement.name}}</option>
          </select>
        </div>
        <div class="form-group mt-4">
          <label for="building" class="form-label ms-2">Edificio</label>
          <select class="form-select rounded-4 bg-transparent" formControlName="building_id" (change)="selectBuilding($event)">
            <option selected value="">Edificio</option>
            <option *ngFor="let building of buildings" [value]="building.id" >{{building.name}}</option>
          </select>
        </div>
        <div class="form-group mt-4">
          <label for="floor" class="form-label ms-2">Piso</label>
          <select class="form-select rounded-4 bg-transparent" formControlName="floor_id" (change)="selectFloor($event)">
            <option selected value="">Piso</option>
            <option *ngFor="let floor of floors" [value]="floor.id" >{{floor.name}}</option>
          </select>
        </div>
        <div class="form-group mt-4">
          <label for="settlement" class="form-label ms-2">Departamento</label>
          <select class="form-select rounded-4 bg-transparent" formControlName="unit_id" (change)="selectUnit($event)">
            <option selected value="">Depto.</option>
            <option *ngFor="let unit of units" [value]="unit.id" >{{unit.name}}</option>
          </select>
        </div>
        <div class="form-group mt-4">
          <label for="settlement" class="form-label ms-2">Ordenar</label>
          <select class="form-select rounded-4 bg-transparent" formControlName="sort" (change)="selectSort($event)">
            <option selected [selected]="true"></option>
            <option value="id">Folio</option>
            <option value="created_at">Fecha creación</option>
            <option value="name">Nombre unidad</option>
          </select>
        </div>
        <div class="btn-group-toggle" data-toggle="buttons">
            <label class="btn btn-outline-secondary btn-sm rounded-5">
              <input type="checkbox" checked autocomplete="off" formControlName="order" (change)="selectOrder($event)"> <fa-icon [icon]="icons.faSort" class="ms-2"></fa-icon> Ordenar
            </label>
          </div>
        <div class="form-group mt-4">
          <label for="settlement" class="form-label ms-2">Resultados por página</label>
          <select class="form-select rounded-4 bg-transparent" formControlName="per_page" (change)="selectPerPage($event)">
            <option selected value="50">Resultados por página</option>
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </select>
        </div>
        <div class="form-group mt-4">
            <button type="submit" class="btn btn-zazz-dark rounded-4 shadow-sm px-4" [disabled]="filterForm.invalid">Filtrar</button>
        </div>
      </form>
    </div>
  `,
  styleUrls: []
})
export class FullFilterComponent implements OnInit {
  @Input() profile: any;
  @Input() toDate: NgbDate | null;
  @Input() fromDate: NgbDate | null;
  @Input() payload: any;
  @Input() showLegalEntity = false;

  @Output() dateRange = new EventEmitter<any>();
  @Output() billsSettlement = new EventEmitter<any>();
  @Output() billsBuilding = new EventEmitter<any>();
  @Output() billsFloor = new EventEmitter<any>();
  @Output() billsUnit = new EventEmitter<any>();
  @Output() billsSort = new EventEmitter<any>();
  @Output() billsOrder = new EventEmitter<any>();
  @Output() billsPerPage = new EventEmitter<any>();
  @Output() clear = new EventEmitter<any>();

  settlements: any = [];
  buildings: any = [];
  floors: any = [];
  units: any = [];

  searchActive: boolean = false;

  filterForm: FormGroup = new FormGroup({});

  constructor(
    private store: SettlementsService,
    private router: Router,
    private route: ActivatedRoute,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    public icons: IconsService,
    private fb: FormBuilder,
    public activeOffcanvas: NgbActiveOffcanvas,
  ) { 
    this.fromDate = calendar.getToday();
		this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
  }

  ngOnInit(): void {
    this.initForm();
    this.loadSettlements();

    console.log("CANVAS PAYLOAD ====> ", this.payload);
    console.log('CANVAS PROFILE ====> ', this.profile);
  }

  initForm() {
    this.filterForm = this.fb.group({
      settlement_id: [''],
      building_id: [''],
      floor_id: [''],
      unit_id: [''],
      sort: [''],
      order: [''],
      per_page: [''],
      tipo: [null],
      legal_entity_id: [null]
    });

    this.filterForm.patchValue(this.payload);
  }

  dismiss() {
    this.activeOffcanvas.dismiss('Cross click');
  }

  close() {
    if (this.filterForm.invalid) return;
    let payload: any = {};
    const ff = this.filterForm.value;
    if (ff.settlement_id) {
      payload.settlement_id = ff.settlement_id;
    }
    if (ff.building_id) {
      payload.building_id = ff.building_id;
    }
    if (ff.floor_id) {
      payload.floor_id = ff.floor_id;
    }
    if (ff.unit_id) {
      payload.unit_id = ff.unit_id;
    }
    if (ff.sort) {
      payload.sort = ff.sort;
    }
    if (ff.per_page) {
      payload.per_page = ff.per_page;
    }
    if (ff.tipo !== null) {
      payload.tipo = ff.tipo;
    }
    if (this.showLegalEntity && ff.legal_entity_id) payload.legal_entity_id = ff.legal_entity_id;
    this.activeOffcanvas.close(payload);
  }

  updateSettlementType(event: any, type: number) {
  if (event.target.checked) {
    // Uncheck the other checkbox
    if (type === 0) {
      const commercialCheckbox = document.getElementById('commercialCheck') as HTMLInputElement;
      if (commercialCheckbox) commercialCheckbox.checked = false;
    } else {
      const residentialCheckbox = document.getElementById('residentialCheck') as HTMLInputElement;
      if (residentialCheckbox) residentialCheckbox.checked = false;
    }
    
    this.filterForm.patchValue({ tipo: type });
    
    // Update settlements list with filter
    let settlementPayload: any = {
      page: 1,
      per_page: 300,
      utility_id: this.profile.utility_id,
      tipo: type
    };
    
    this.store.getSettlements(settlementPayload).subscribe((data: any) => {
      this.settlements = data.data;
    });
  } else {
    this.filterForm.patchValue({ tipo: null });
    this.loadSettlements(); // Reset to show all settlements
  }
}

  loadSettlements(id: any = null) {
    let settlementPayload: any = {
      page: 1,
      per_page: 300,
      utility_id: this.profile.utility_id
    };
    this.store.getSettlements(settlementPayload).subscribe((data: any) => {
      this.settlements = data.data;
      
      console.log("PAYLOAD SETTLEMENTS ====> ", this.payload);
      if (this.payload?.settlement_id != null) {
        this.filterForm.patchValue({ settlement_id: this.payload.settlement_id });
        this.preloadBuildings(this.payload.settlement_id, this.payload.building_id);
      }
    });
  }

  preloadBuildings(settlement_id: any, id: any = null) {
    let buildingPayload: any = {
      page: 1,
      per_page: 300,
      settlement_id: settlement_id
    };

    this.store.getBuildings(buildingPayload).subscribe((data: any) => {
      this.buildings = data.data;
    });

    this.store.getFloors({
      page: 1,
      per_page: 300,
      building_id: id
    }).subscribe((data: any) => {
      this.floors = data.data;
    });

    this.filterForm.patchValue({ building_id: id });
    if (this.payload.floor_id != null) {
      this.filterForm.patchValue({ floor_id: this.payload.floor_id });
      this.preloadUnits(this.payload.floor_id, this.payload.unit_id);
    }
  }

  preloadFloors(building_id: any, id: any = null) {
    let floorPayload: any = {
      page: 1,
      per_page: 300,
      building_id: building_id
    };

    this.store.getFloors(floorPayload).subscribe((data: any) => {
      this.floors = data.data;
    });

    this.store.getUnits({
      page: 1,
      per_page: 300,
      floor_id: id
    }).subscribe((data: any) => {
      this.units = data.data;
    });

    this.filterForm.patchValue({ floor_id: id });
  }

  preloadUnits(floor_id: any, id: any = null) {
    let unitPayload: any = {
      page: 1,
      per_page: 300,
      floor_id: floor_id
    };

    this.store.getUnits(unitPayload).subscribe((data: any) => {
      this.units = data.data;
    });
    this.filterForm.patchValue({ unit_id: id });
    if (this.payload.unit_id != null) {
      this.filterForm.patchValue({ unit_id: this.payload.unit_id });
    }
  }

  selectSettlement(event: any) {
    let buildingPayload: any = {
      page: 1,
      per_page: 300,
      settlement_id: event.target.value
    };

    this.filterForm.patchValue({ building_id: '', floor_id: '', unit_id: '' });
    
    this.store.getBuildings(buildingPayload).subscribe((data: any) => {
      this.buildings = data.data;
      this.searchActive = true;
    });

    this.filterForm.patchValue({ settlement_id: event.target.value });

    this.billsSettlement.emit(event.target.value);
  }

  selectBuilding(event: any) {
    let unitPayload: any = {
      page: 1,
      per_page: 300,
      building_id: event.target.value
    };
    this.store.getFloors(unitPayload).subscribe((data: any) => {
      this.floors = data.data;
    });

    this.filterForm.patchValue({ floor_id: '', unit_id: '' });

    this.units = [];

    this.billsBuilding.emit(event.target.value);
  }

  selectFloor(event: any) {
    let unitPayload: any = {
      page: 1,
      per_page: 300,
      floor_id: event.target.value
    };
    this.store.getUnits(unitPayload).subscribe((data: any) => {
      this.units = data.data;
      console.log("UNITS => ", data);
    });

    this.filterForm.patchValue({ unit_id: '' });

    this.billsFloor.emit(event.target.value);
  }

  selectUnit(event: any) {
    this.billsUnit.emit(event.target.value);
  }

  selectSort(event: any) {
    console.log('SORT ====> ', event.target.value);
    this.billsSort.emit(event.target.value);
  }

  selectOrder(event: any) {
    console.log('ORDER ====> ', event.target.checked);
    this.billsOrder.emit(event.target.checked ? 'ASC' : 'DESC');
  }

  selectPerPage(event: any) {
    console.log('PER PAGE ====> ', event.target.value);
    this.billsPerPage.emit(event.target.value);
  }

  clearFilter() {    
    this.settlements = [];
    this.units = [];
    this.floors = [];
    this.buildings = [];
    this.searchActive = false;
    // this.fromDate = this.calendar.getToday();
    // this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 10);
    this.filterForm.reset();
    this.loadSettlements();
    this.clear.emit();
  }

}
